'use strict';

angular.module('cloudBillingLegacyFrontend').controller('CspUpdateEAAccountCtrlMixin', function($scope, $modal) {

  $scope.openCspUpdateEAAccountDialog = function(exitingAccountModel) {

    var modalInstance = $modal.open({
      templateUrl: "views/csp/modals/modal_ac_csp_update_ea_account.html",
      controller: 'ModalCspUpdateEAAccountCtrl',
      resolve: {
        AccountModel: function() {
          return exitingAccountModel ? exitingAccountModel : {};
        }
      }
    });

    // returns a promise
    return modalInstance.result;
  };
});
